import React, {  useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ShowSupportPartnersContext } from './types';
import { DeletePartnerSupportApi } from '../../../redux/partners/partnerApiCalls';
import { useParams } from 'react-router';
import { Timeout } from '../../../functions/functions';
import ShowErrorMsg from '../../../HtmlComponents/ShowErrorMsg';
import ButtonsForm from '../../../HtmlComponents/ButtonsForm';

interface props {
  modal: boolean,
  toggle: () => void,
}

const DeleteSupportAssModal:React.FC<props> = ({ modal, toggle }) => {

  const [errors, setErrors] = useState<string[]>([])

  const [loading, setLoading] = useState(false)

  const { setShowSuccessMsg, selectedSupportAss } = useContext(ShowSupportPartnersContext)

  const dispatch:any = useDispatch()

  const { AssId } = useParams()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response: any = await dispatch(DeletePartnerSupportApi(AssId, selectedSupportAss._id))
        if(response === true) {
          setShowSuccessMsg(true)
          setErrors([])
          toggle()
          setTimeout(() => setShowSuccessMsg(false), Timeout)
        } else {
          setErrors(response)
        }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>      
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType='multipart/form-data'
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm loading={loading} toggle={toggle} typeBtn='Supprimer' />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DeleteSupportAssModal
